import { render } from "./PublicationAiAppBasicDetails.vue?vue&type=template&id=4814f46c&lang=true"
import script from "./PublicationAiAppBasicDetails.vue?vue&type=script&lang=js"
export * from "./PublicationAiAppBasicDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__